
















import {Component, Prop, Vue} from 'vue-property-decorator';
import HeaderAndCrumbs from '@/components/Views/Home Page/HeaderAndCrumbs.vue';
import HeroImage from '@/components/Views/Home Page/HeroImage.vue';
import PageWithSidebar from '@/components/Views/Home Page/PageWithSidebar.vue';

@Component({
    components: {
        PageWithSidebar,
        HeroImage,
        HeaderAndCrumbs,
    },
})
export default class LocationsPage extends Vue {
    @Prop({default: () => []})
    public crumbs!: any[];

    @Prop({default: ''})
    public header!: string;

    @Prop({default: ''})
    public heroText!: string;

    @Prop({default: ''})
    public subLocations!: string | string[];

    @Prop({default: () => []})
    public bodyTop!: string[];

    @Prop({default: () => []})
    public bodyBottom!: string[];

    @Prop({default: () => []})
    public services!: [];

    @Prop({default: undefined})
    public image!: string;

}
